import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for transactions page context.
 * Combines all data needed by the Transactions component.
 */
export const selectTransactionsPageContext = createSelector(
  [(state: RootState) => state.transactionsStore, (state: RootState) => state.userStore],
  (transactionsStore, userStore) => ({
    // Transactions data
    transactions: transactionsStore.transactions,
    transactionsTotalSize: transactionsStore.transactionsTotalSize,
    transactionsLoading: transactionsStore.transactionsLoading,
    transactionsLoaded: transactionsStore.transactionsLoaded,
    transactionsError: transactionsStore.transactionsError,
    // User data
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
  })
);
